<template>
  <div class="home">
    <div class="block">
      <el-carousel :interval="4000" type="card" height="400px" arrow="always">
        <el-carousel-item v-for="item in src" :key="item.id">
          <el-image :src="item.path"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <Service></Service>
    <!-- <Product></Product> -->
    <News></News>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Service from './Model/Service'
// import Product from './Model/Product'
import News from './Model/News'
export default {
  name: 'Home',
  components: {
    Service,
    // Product,
    News
  },
  data() {
    return {
      img: [],
      src: [
        {
          id: '0',
          path:
            'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
        },
        {
          id: '1',
          path:
            'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1600158610775&di=bd7235d15023a8bb38d37642a7f6a3fb&imgtype=0&src=http%3A%2F%2Foss.jvtd.cn%2Fuploads%2F1527070255_930455193.jpg'
        },
        {
          id: '2',
          path:
            'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1600158610775&di=adf2c2314a2b29b28203e1295a0d5d3f&imgtype=0&src=http%3A%2F%2Fwww.duozhishidai.com%2Fdata%2Fattachment%2Fportal%2F201809%2F23%2F172226xk9yyo0mfk005i4g.jpg'
        }
      ]
    }
  }
}
</script>
<style lang="scss">
</style>

